import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";

@Component({
  selector: "app-homepage-overview",
  templateUrl: "./homepage-overview.component.html",
  styleUrls: ["./homepage-overview.component.scss"],
})
export class HomepageOverviewComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

  ngOnInit() {
    this.Form = this.formBuilder.group({
      vision: [""],
      mission: [""],
      // brochure: [""],
      _id: [""],
    });

    this.http.get<any>(this.api_endpoint + "/homepage-overview-findone/").subscribe(
      (data) => {
        if (data.data != null) {
          this.action = "Update";
          this.Form.patchValue({
            vision: data.data.vision,
            mission: data.data.mission,
            // brochure: data.data.brochure,
            _id: data.data._id,
          });
        } else {
          this.action = "Submit";
          this.Form.patchValue({
            vision: "",
            mission: "",
            // brochure: "",
            _id: "",
          });
        }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      }
    );
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit(action) {
    const formData = {
      vision: this.Form.value.vision,
      mission: this.Form.value.mission,
      // brochure: this.Form.value.brochure,
      _id: this.Form.value._id,
    };

    this.submitted = true;
    if (action == "Update") {
      this.http
        .put<any>(this.api_endpoint + "/homepage-overview", formData)
        .subscribe(
          (res) => {
            // console.log(res);
            if (res.Error) {
              this.message = res.Error;
              this.class = "btn btn-primary";
              return;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn btn-success";
            }
            window.location.reload();
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    } else if (action == "Submit") {
      delete formData._id;
      this.http
        .post<any>(this.api_endpoint + "/homepage-overview", formData)
        .subscribe(
          (res) => {
            // console.log(res);
            if (res.Error) {
              this.message = res.Error;
              this.class = "btn btn-primary";
              return;
            } else {
              this.message = "Successfully Added";
              this.class = "btn btn-success";
            }
            window.location.reload();
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }
}
